export enum SortingOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export type CustomSortingState = {
  sortBy: string;
  sortOrder: SortingOrder;
};
